// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oXNi2","select":"styles_select__1oWVf"};